


































import Vue from 'vue';
import { mapGetters } from 'vuex';

import HAvatar from '@/ui/components/base/HAvatar.vue';
import HButtonIcon from '@/ui/components/base/HButtonIcon.vue';

import { ObjectLike } from '../../../types/objectlike.types';

export default Vue.extend({
  name: 'ProfileCover',
  components: {
    HAvatar,
    HButtonIcon,
  },
  computed: {
    ...mapGetters({
      profile: 'profile/profile',
      user: 'user/user',
    }),
    bgStyle(): ObjectLike {
      if (this.profile && this.profile.profileCover) {
        return {
          backgroundImage: `url(${this.profile.profileCover})`,
        };
      }

      return {};
    },
  },
  data() {
    // TODO edit this loading
    return {
      loading: false,
    };
  },
  methods: {
    goToEditProfile() {
      this.$router.push({
        name: 'ProfileEdit',
      });
    },
  },
});
